export default __webpack_public_path__ + "static/media/DownArrow.608cc3e7.svg";